import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const REQUEST_TIMEOUT = 30000;

const axiosInstance = axios.create({
    baseURL: '/api/',
    timeout: REQUEST_TIMEOUT,
    headers: {
        'Content-type': 'application/json; charset=utf-8',
    },
});

const useAPI = (endpoint, shouldFetch = true) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async () => {
        if (!shouldFetch) {
            setLoading(false);
            return;
        }
        try {
            setLoading(true);
            const response = await axiosInstance.get(endpoint);
            setData(response.data);
            setError(null);
        } catch (err) {
            setError(err.message || 'An error occurred while fetching data');
            setData(null);
        } finally {
            setLoading(false);
        }
    }, [endpoint, shouldFetch]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return { data, loading, error };
};

export default useAPI;
